module.exports = __webpack_public_path__ + "media/images/icons/gear-16469851a4874f9c00f75197dc65c993.svg";